module.exports = __webpack_public_path__ + "static/rocket-to-phone-1d09cc387e809517ed03c5dd181c31ae.gif";